import React from 'react';



import "@fontsource/mulish"; // Defaults to weight 400.


import { BrowserRouter } from 'react-router-dom';

import Main from './components/Main';





function App() {
 
  return (  
    
    <div>      
      
      <BrowserRouter>
        <Main/>
      </BrowserRouter>

    </div>

    

  );
}





export default App;
